import Api from '@/services/Api'

export default {
    getModels (params) {
 
        if(params.model && typeof params.model !== 'undefined'){
            
            return Api().get('/' + params.model + '.json')
        }else{

            return Api().get('/.json')
        }
       
    }
}